<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 32 32"
    :width="size"
    :height="size"
  >
    <path
      fill="currentColor"
      d="M29.768 9.611l-7.437-1.228-3.965-7.027c-0.467-0.816-1.331-1.356-2.322-1.356h-0.229c0 0 0 0-0 0-1.005 0-1.88 0.556-2.334 1.377l-0.007 0.014-3.813 6.994-7.427 1.226c-1.274 0.216-2.232 1.312-2.232 2.631v0 0.34c0 0.655 0.236 1.254 0.627 1.718l-0.003-0.004 5.099 6.077-1.46 8.51c-0.024 0.136-0.038 0.292-0.038 0.451 0 1.473 1.194 2.667 2.667 2.667 0 0 0 0 0 0h0.67c0.454 0 0.881-0.113 1.255-0.313l-0.014 0.007 7.182-3.776 7.214 3.778c0.359 0.192 0.785 0.304 1.237 0.304h0.672c1.473 0 2.667-1.194 2.667-2.667 0-0.159-0.014-0.315-0.041-0.467l0.002 0.016-1.46-8.51 5.099-6.077c0.388-0.46 0.624-1.060 0.624-1.714v0-0.34c-0-1.319-0.958-2.415-2.217-2.629l-0.016-0.002zM29.333 12.581l-5.894 7.023 1.669 9.729h-0.672l-8.454-4.426-8.421 4.426h-0.671l1.669-9.729-5.894-7.023v-0.339l8.712-1.439 4.436-8.137h0.257l4.561 8.138 8.702 1.438z"
    />
  </svg>
</template>

<script>
export default {
  name: 'SvgStar',

  props: {
    size: {
      type: [Number, String],
      default: 32,
    },
  },
}
</script>
